<template>
    <div class="historical-import-wrapper">
        <div v-if="showFlag === 1">
            <tableList
                    :loading="false"
                    :index-show="showIndex"
                    :table-data="tableData"
                    :row-key="rowKey"
                    :table-label="tableLabel" style="margin-top: 20px">
                <template v-slot:operation="slot">
                    <div  @click="downFile(slot.scope.row.fileUrl)" class="down-box">下载</div>
                </template>
            </tableList>
            <e-pager style="margin-top: 20px"
                     :page-index="orderPage.pageNum"
                     :total="orderPage.pageTotal"
                     :page-size="orderPage.pageSize"
                     @change="handleCurrentChange"></e-pager>
        </div>
        <div class="flex-column" v-if="showFlag === 2">
            <img src="../../../../../assets/img/order-no-data.png" alt="">
            <div class="no-data-tip">暂无类目导入</div>
        </div>
    </div>
</template>

<script>
    import tableList from "../../../components/common/e-table-list";
    import ePager from "../../../components/common/e-pager";
    import api from '@/modules/projectA/api/purchase';
    import utils from "../../../utils/utils";
    export default {
        name: "historicalImportDetails",
        components: {tableList, ePager},
        data() {
            return {
                showFlag:0,
                isSimple:true,
                orderPage:{
                    pageNum:1,
                    pageSize:10,
                    pageTotal:0,
                },
                tableData: [],
                showIndex: true,
                rowKey: '',
                tableLabel: [
                    {label: "文件名称", param: "fileName", align: "center"},
                    {label: "总数量", param: "totalNumber", align: "center",width:'110'},
                    {label: "成功数量", param: "successNumber", align: "center",width:'110'},
                    {label: "失败数量", param: "failNumber", align: "center",width:'110'},
                    {label: "创建时间", param: "createTime", align: "center",width:'160'},
                    {label: "操作", param: "", align: "center", slot: 'operation',width:'100'},
                ],
                pageData:{
                    pageNum:1,
                    pageSize:10,
                },
            }
        },
        methods:{
            downFile(fileUrl){
                this.getBlob(fileUrl).then(blob => {
                    this.saveAs(blob, '分类映射导入详情')
                })
            },
            //下载文件 　　js模拟点击a标签进行下载
            saveAs(blob, filename) {
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                link.click();
            },
            getBlob(url) {
                return new Promise(resolve => {
                    const xhr = new XMLHttpRequest()
                    xhr.open('GET', url, true)
                    xhr.responseType = 'blob'
                    xhr.onload = () => {
                        if (xhr.status === 200) {
                            resolve(xhr.response)
                        }
                    }
                    xhr.send()
                })
            },
            categorUploadPage(){
                api.categorUploadPage(this.pageData).then(res => {
                    if (res.success) {
                         this.tableData = res.data.records || [];
                         this.orderPage.pageTotal = res.data.total;
                        if(this.tableData.length === 0){
                            this.showFlag = 2;
                        }else{
                            this.showFlag = 1;
                        }
                    }
                });
            },
            handleCurrentChange(val){
                this.pageData.pageNum = val;
                this.categorUploadPage();
            },
        },
        mounted() {
            this.categorUploadPage();
        }
    }
</script>

<style scoped lang="scss">
    .historical-import-wrapper {
        min-height: 402px;
        max-height: 630px;
        background: #FFF;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        padding: 20px;

        img {
            width: 204px;
            height: 160px;
            margin-top: 30px;
            margin-bottom: 20px;
        }

        .no-data-tip {
            font-weight: 500;
            font-size: 16px;
        }

        .down-box {
            color: #126edf;
            cursor: pointer;
            &:hover{
                color: #0064C8;
            }
        }
    }
</style>